export const GetUnixDate = (datetime) => {
  return datetime.setHour(0).setMinute(0).setSecond(0).toUnix() * 1000;
};
